import { createAction } from '@reduxjs/toolkit';
import { ActionType } from '../enums';

const createActionBuilder =
  <T extends ActionType = ActionType>(_: T) =>
  <P = void, U extends string = string>(type: `${T}/${U}`) =>
    createAction<P, `${T}/${U}`>(type);

export const createCommand = createActionBuilder(ActionType.COMMAND);

export const createEvent = createActionBuilder(ActionType.EVENT);

export const createError = createActionBuilder(ActionType.ERROR);
